import { useLocation } from "react-router";
import { authClient } from "@/lib/auth-client";

import { GuestTopNav } from "./guest-top-nav";
import { PlatformTopNav } from "./platform-top-nav";

export function TopNav() {
  const location = useLocation();
  const { data } = authClient.useSession();
  const user = data?.user;

  const currentRoute = location.pathname;
  const isPlatformRoute = currentRoute.startsWith("/platform");

  return (
    <nav className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      {user && isPlatformRoute ? <PlatformTopNav user={user} /> : <GuestTopNav />}
    </nav>
  );
}
